<div class="page-title animatedBackground">
    <div class="container">
        <h3>Openbravo</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li><a routerLink="/our-solutions">Our Solutions</a></li>
            <li class="dot-divider"></li>
            <li>Openbravo</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-desc">
                <h3>Boost agility and accelerate your unified commerce journey</h3>
                <p>From master data maintenance to merchandise planning and distribution, Openbravo allows faster and more frequent product introductions as well as more effective allocation and replenishment processes.</p>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> SIMPLIFY MANAGEMENT OF YOUR MULTI-STORE OPERATIONS</h4>
                    <p>By adopting Openbravo, companies gain greater agility and scalability across locations, and significant operational improvements in areas such as rapid setup of new stores, simplified store assortment, product and pricing management and real-time visibility on sales and inventory across the whole physical stores network.</p>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> ENABLE SMARTER WAREHOUSE MANAGEMENT</h4>
                    <p>Empower Your Business To Pursue Operational Warehouse Excellence, Optimize Working Capital And Achieve Omnichannel Success.</p>
                </div>
            </div>

            <div class="services-details-image">
                <img style="border-radius:25px ;" src="assets/img/openbravo.png" alt="image">
            </div>
        </div>

        <div class="services-details-overview">
            <div class="services-details-image">
                <img src="assets/img/openbravo2.png"  style="border-radius:25px ;" alt="image">
            </div>

            <div class="services-details-desc">
                <h3>Key Features</h3>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Merchandise Planning</h4>
                    <h4><i class="icofont-check-alt"></i> Merchandise Distribution</h4>
                    <h4><i class="icofont-check-alt"></i> Manufacturing Management</h4>
                    <h4><i class="icofont-check-alt"></i> Warehouse and inventory Management</h4>
                    <h4><i class="icofont-check-alt"></i> Purchasing</h4>
                    <h4><i class="icofont-check-alt"></i> Shipping and transportation Management</h4>
                    <h4><i class="icofont-check-alt"></i> Finance & Accounting</h4>
                    
                </div>
                
            </div>
        </div>
    </div>
</section>

